var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text","value":"","id":"copier"}}),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"kinematicsInput"}}),_c('chain-list',{attrs:{"bus":_vm.chainListBus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }